import React from "react";
import { Flex } from "@chakra-ui/react";
import LimitsTable from "../components/Tables/components/Limits";

export default function Limits() {
    const columns = React.useMemo(
        () => [
            {
                header: 'id',
                accessorKey: 'id'
            },
            {
                header: 'reset_schedule',
                accessorKey: 'reset_schedule',
            },
            {
                header: 'type',
                accessorKey: 'type',
            },
            {
                header: 'limit',
                accessorKey: 'limit',
            },
            {
                header: 'parent_terminal',
                accessorKey: 'parent_terminal',
            },
            {
                header: 'parent_profile',
                accessorKey: 'parent_profile',
            },
            {
                header: 'action',
                accessorKey: 'action',
            }
        ],
        [])

    return (
        <Flex direction='column' pt={{ base: "150px", md: "75px" }}>
            <LimitsTable
                title={"Лимиты"}
                columns = {columns}
            />
        </Flex>

    );
}
